var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/profile-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.0002 40.5H29.0002C28.1802 40.5 27.5002 39.82 27.5002 39C27.5002 38.18 28.1802 37.5 29.0002 37.5H37.0002C37.8202 37.5 38.5002 38.18 38.5002 39C38.5002 39.82 37.8202 40.5 37.0002 40.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.0002 44.5C32.1802 44.5 31.5002 43.82 31.5002 43V35C31.5002 34.18 32.1802 33.5 33.0002 33.5C33.8202 33.5 34.5002 34.18 34.5002 35V43C34.5002 43.82 33.8202 44.5 33.0002 44.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.3204 23.24C24.2604 23.24 24.2204 23.24 24.1604 23.24C24.0604 23.22 23.9204 23.22 23.8004 23.24C18.0004 23.06 13.6204 18.5 13.6204 12.88C13.6004 10.12 14.6804 7.52 16.6404 5.56C18.6004 3.6 21.2004 2.5 23.9804 2.5C29.7004 2.5 34.3604 7.16 34.3604 12.88C34.3604 18.5 29.9804 23.04 24.3804 23.24C24.3604 23.24 24.3404 23.24 24.3204 23.24ZM23.9804 5.5C22.0004 5.5 20.1604 6.28 18.7604 7.66C17.3804 9.06 16.6204 10.9 16.6204 12.86C16.6204 16.86 19.7404 20.1 23.7204 20.22C23.8404 20.2 24.1004 20.2 24.3604 20.22C28.3004 20.04 31.3604 16.82 31.3604 12.86C31.3604 8.82 28.0404 5.5 23.9804 5.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.9803 45.12C19.9003 45.12 16.0403 44.06 13.1203 42.1C10.3403 40.24 8.82031 37.7 8.82031 34.96C8.82031 32.22 10.3603 29.7 13.1203 27.86C19.1003 23.86 28.8203 23.86 34.8003 27.86C35.4803 28.32 35.6803 29.26 35.2203 29.94C34.7603 30.64 33.8203 30.82 33.1403 30.36C28.1603 27.04 19.7603 27.04 14.7803 30.36C12.8603 31.64 11.8203 33.26 11.8203 34.96C11.8203 36.66 12.8603 38.32 14.7803 39.6C17.2003 41.22 20.4603 42.1 23.9603 42.1C24.7803 42.1 25.4603 42.78 25.4603 43.6C25.4603 44.42 24.8003 45.12 23.9803 45.12Z",
    fill: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAdd);
export default __webpack_public_path__ + "static/media/profile-add.5050e8d8431bbcb2ba5d9e395fb4a5a0.svg";
export { ForwardRef as ReactComponent };